import { ProgressBarDesignTokens } from '@primeng/themes/types/progressbar';

interface ICustomProgressBarDesignTokens extends ProgressBarDesignTokens {
  root: ProgressBarDesignTokens['root'] & {
    borderWidth?: string;
    borderColor?: string;
  };
}

export const baseProgressbarToken: ICustomProgressBarDesignTokens = {
  root: {
    background: '{surface.0}',
    borderWidth: '1px',
    borderColor: '{content.border.color}',
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
    p-progressbar .p-progressbar {
      border-width: ${dt('progressbar.borderWidth')};
      border-color: ${dt('progressbar.borderColor')};
    }
     `,
};
